export default __webpack_public_path__ + "static/media/card4.e3d95d17.jpg";